// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children, requireProfileComplete = false }) => {
//   // Check if user is authenticated
//   const isAuthenticated = () => {
//     const token = localStorage.getItem('authToken');
//     const userId = localStorage.getItem('userId');
    
//     // You can add more validation here if needed
//     return token && userId;
//   };

//   // Check if profile is complete
//   const isProfileComplete = () => {
//     const isProfileCreated = localStorage.getItem('isProfileCreated') === 'true';
//     const userData = localStorage.getItem('userData');
//     return isProfileCreated && userData;
//   };

//   if (!isAuthenticated()) {
//     // User not logged in, redirect to login page
//     return <Navigate to="/" replace />;
//   }

//   // If route requires profile to be complete, check it
//   if (requireProfileComplete && !isProfileComplete()) {
//     // Profile not complete, redirect to register page
//     return <Navigate to="/register" replace />;
//   }

//   // User is logged in, show the protected content
//   return children;
// };

// export default ProtectedRoute;

// src/WebComponents/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireProfileComplete = false }) => {
  // Check if user is authenticated
  const isAuthenticated = () => {
    const token = localStorage.getItem('authToken');
    const userId = localStorage.getItem('userId');
    
    // You can add more validation here if needed
    return token && userId;
  };

  // Check if profile is complete
  const isProfileComplete = () => {
    const isProfileCreated = localStorage.getItem('isProfileCreated') === 'true';
    const userData = localStorage.getItem('userData');
    return isProfileCreated && userData;
  };

  if (!isAuthenticated()) {
    // User not logged in, redirect to home page
    return <Navigate to="/" replace />;
  }

  // If route requires profile to be complete, check it
  if (requireProfileComplete && !isProfileComplete()) {
    // Profile not complete, redirect to register page
    return <Navigate to="/register" replace />;
  }

  // User is logged in, show the protected content
  return children;
};

export default ProtectedRoute;